// extracted by mini-css-extract-plugin
export var contextualStoreBackgroundDark = "#1a1b1e";
export var guideDetail = "DevReadinessGuide-module__guideDetail___oUI+g";
export var guideDetailAction = "DevReadinessGuide-module__guideDetailAction___c4J0a";
export var guideDetailDivider = "DevReadinessGuide-module__guideDetailDivider___3pnqi";
export var guideDetailExternalIcon = "DevReadinessGuide-module__guideDetailExternalIcon___o8K00";
export var guideDetailLink = "DevReadinessGuide-module__guideDetailLink___zx66f";
export var guideDetailLinkIcon = "DevReadinessGuide-module__guideDetailLinkIcon___GH09A";
export var guideDetailSubtext = "DevReadinessGuide-module__guideDetailSubtext___+bKWa";
export var guideDetailText = "DevReadinessGuide-module__guideDetailText___3KP92";
export var sidebar = "DevReadinessGuide-module__sidebar___IueRT";
export var sidebarClose = "DevReadinessGuide-module__sidebarClose___PhDkr";
export var sidebarHeader = "DevReadinessGuide-module__sidebarHeader___CbhPb";
export var sidebarItem = "DevReadinessGuide-module__sidebarItem___4ef4j";
export var sidebarItemIcon = "DevReadinessGuide-module__sidebarItemIcon___7ke1V";
export var sidebarItemIconOpen = "DevReadinessGuide-module__sidebarItemIconOpen___mFQ-W";
export var sidebarItemLabel = "DevReadinessGuide-module__sidebarItemLabel___YNIUS";
export var sidebarSection = "DevReadinessGuide-module__sidebarSection___SJTPd";
export var sidebarSubtitle = "DevReadinessGuide-module__sidebarSubtitle___k3Iei";
export var sidebarTitle = "DevReadinessGuide-module__sidebarTitle___SS8yt";